module.exports = __webpack_public_path__ + "img/socialMediaLinkedinNavy.9d6b1c8f.svg";